import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { Alert } from "@material-ui/lab";

const PostIngestionWarning: React.FC = () => {
  return (
    <>
      <Grid item xs={12}>
        <Alert severity="error">
          <Typography
            variant="body2"
            style={{
              fontWeight: "bold",
              marginBottom: 8,
              display: "flex",
              alignItems: "center",
              gap: 8,
            }}
          >
            CRITICAL: Known Issues with Post-Ingestion Customer Creation
          </Typography>
          <Typography variant="body2" style={{ marginBottom: 4 }}>
            <strong>Issue 1 - Duplicate Profile:</strong> Creating an AP
            customer after ingesting the prescription may create a duplicate
            profile instead of mapping to the existing customer data.
          </Typography>
          <Typography variant="body2" style={{ marginBottom: 4 }}>
            <strong>Issue 2 - Rx Association:</strong> The ingested prescription
            (Rx) may NOT get associated with the newly created customer profile,
            leaving the Rx orphaned.
          </Typography>
          <Typography
            variant="body2"
            style={{ marginTop: 8, fontStyle: "italic" }}
          >
            <strong>Recommendation:</strong> Use the "Existing AP Customer"
            workflow, or create the customer through Pharmacy Beta UI manually
            to avoid these issues.
          </Typography>
        </Alert>
      </Grid>
      <Grid item xs={12}>
        <Alert severity="warning">
          <Typography variant="body2" style={{ fontWeight: "bold" }}>
            Only proceed if you understand the risks above
          </Typography>
        </Alert>
      </Grid>
    </>
  );
};

export default PostIngestionWarning;
